import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { DuplicatedNfError } from "../../domain/errors/duplicated-nf-error";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { Cargo, NormalizedCargo } from "../../domain/models/cargo-model";
import { Receipt, ReceiptNF } from "../../domain/models/receipt-model";
import { AddCargoResult, SaveCargo } from "../../domain/usecases/save-cargo";
import { SaveReceipt } from "../../domain/usecases/save-receipt";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbSaveCargo implements SaveCargo {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async save(cargo: NormalizedCargo): Promise<AddCargoResult> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "post",
      body: cargo,
    });

    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body;
      case HttpStatusCode.forbidden:
        throw new DuplicatedNfError(res.body.error.data);
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
